import UnlinkedPaymentFilter from "components/manage/transactions/unlinked_payment/filter";
import UnlinkedPaymentForm from "components/manage/transactions/unlinked_payment/form";

$(() => {
  new Vue({
    el: document.querySelector(".v-linked-withdrawal-controller"),
    components: { UnlinkedPaymentFilter, UnlinkedPaymentForm },
  });
});
